"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_IDP_DRIVERS = exports.COGNITO = exports.PORTAL_ROUTE = void 0;
exports.PORTAL_ROUTE = '/v2/route';
exports.COGNITO = 'cognito';
exports.ALL_IDP_DRIVERS = [exports.COGNITO];
//# sourceMappingURL=models.js.map